import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

export default function MetaTags() {
  const { restaurantConfig } = useSelector((state) => state.config);

  if (!restaurantConfig) {
    return null;
  }

  return (
    <Helmet>
      <title>{restaurantConfig.restaurantName}</title>

      <link rel="icon" href={restaurantConfig.companyLogo} />
      <meta name="description" content="" />
      <link rel="apple-touch-icon" href={restaurantConfig.companyLogo} />

      {/* <link rel="manifest" href={restaurantConfig.manifestJsonURL} /> */}
    </Helmet>
  );
}
